import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
  idpreset: '',
  nomepresetreceita: '',
};

export default function logsDescarregamentosItem(
  state = INITIAL_STATE,
  action
) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@logsdescarregamentositem/FIND_DATA':
      case '@logsdescarregamentositem/UPDATE_DATA':
      case '@logsdescarregamentositem/DELETE_DATA':
      case '@logsdescarregamentositem/STORE_DATA': {
        draft.loading = true;
        break;
      }

      case '@logsdescarregamentositem/SUCCESS_REMOVE':
      case '@logsdescarregamentositem/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@logsdescarregamentositem/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.data;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@logsdescarregamentositem/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.data;
        break;
      }

      case '@logsdescarregamentositem/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }
      case '@logsdescarregamentositem/SET_PRESET_PRODUTO': {
        draft.idpreset = action.payload.preset;
        draft.nomepresetreceita = action.payload.produto;
        break;
      }

      // case '@hooks/RESET': {
      //   draft.data = [];
      //   draft.page = 1;
      //   draft.pageSize = 10;
      //   draft.totalCount = 0;
      //   draft.totalPages = 0;
      //   draft.find = null;
      //   draft.params = {};
      //   break;
      // }

      default:
    }
  });
}
